// extracted by mini-css-extract-plugin
export default {"helperText":"LimitedAutocompleteTextField_helperText__UcZYG font-xs-regular"};